export default __webpack_public_path__ + "static/media/meter-bridge.5ba25b49.jpg";